export const sportMap: Record<string, string> = {
  "football": "football",
  "soccer": "football",
};

/** Normalizes a sport value through sportMap aliases. Returns the input unchanged if not in the map or undefined. */
export const normalizeSport = (sport: string | undefined): string | undefined =>
  sport && sport in sportMap ? sportMap[sport] : sport;
